module.exports = __webpack_public_path__ + "media/images/young_pin_design_award_participate_icon-w@2x-c86dc52aec3477c811a0f52bbbd93a11.png";